export function formatFileBytes(bytes) {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${bytes} B`;
}

export function fileTransferStatusLabel(task) {
  switch (task.status) {
    case 'requested':
      return '发送中';
    case 'connecting':
      return '正在连接';
    case 'waiting-peer':
      return task.direction === 'download' ? '等待你接收' : '等待对方接收';
    case 'available':
      return task.direction === 'download' ? '等待你接收' : '发送中';
    case 'transferring':
      return task.direction === 'download' ? '接收中' : '发送中';
    case 'completed':
      return task.direction === 'download' ? '文件已接收' : '已发送';
    case 'failed':
      return '发送失败';
    default:
      return '';
  }
}

export function shouldShowFileTransferProgress(status) {
  return status === 'connecting' || status === 'waiting-peer' || status === 'transferring';
}

export function fileMessageStatusLabel(message) {
  if (message.status === 'failed') {
    return '发送失败';
  }
  if (message.status === 'pending') {
    return '发送中';
  }
  return message.dir === 'in' ? '' : '已发送';
}

export function realtimeFileTransferStatusLabel(lifecycle, direction) {
  if (lifecycle === false) return '文件记录不可用';
  if (!lifecycle) {
    return '';
  }
  switch (lifecycle.state) {
    case 'offered':
      return direction === 'out' ? '等待对方接收' : '等待接收';
    case 'claimed':
    case 'streaming':
    case 'reconnecting':
      return '传输中';
    case 'completed':
      return direction === 'in' ? '已接收' : '已发送';
    case 'failed':
    case 'expired':
    case 'cancelled':
      return '传输失败';
    default:
      return '';
  }
}
